import React from 'react'
import { FormattedMessage } from 'react-intl'

import {
  questQualityReviewGuidelines,
  allQuestsAreEvaluated,
  afterTheInternalProcessIsComplete,
  usingThe
} from '../../../../utils/messages'

const Guidelines = () => (
  <p className="guidelines">
    <FormattedMessage
      id={'QualityReview.AllQuestsAreEvaluated'}
      defaultMessage={
        '{allQuestsAreEvaluated} {afterTheInternalProcessIsComplete} {usingThe} {guidelines}'
      }
      values={{
        allQuestsAreEvaluated: allQuestsAreEvaluated,
        afterTheInternalProcessIsComplete: afterTheInternalProcessIsComplete,
        usingThe: usingThe,
        guidelines: (
          <a
            href="https://questforward.zendesk.com/hc/en-us/articles/360000115811-Quest-Quality-Review-Guidelines"
            target="_blank"
          >
            {questQualityReviewGuidelines}
          </a>
        )
      }}
    />
    .&nbsp;
    <FormattedMessage
      id={'QualityReview.UponApproval'}
      defaultMessage={
        'Upon approval, the quest is published and released to the Quest! app.'
      }
    />
  </p>
)

export default Guidelines



// WEBPACK FOOTER //
// ./src/components/quest/review/qualityreview/Guidelines.js